import React from "react";
import cloneDeep from "lodash/cloneDeep";
import Table from "@cloudscape-design/components/table";
import Box from "@cloudscape-design/components/box";
import Header from "@cloudscape-design/components/header";
import Link from "@cloudscape-design/components/link";
import Alert from "@cloudscape-design/components/alert";
import Pagination from "@cloudscape-design/components/pagination";
import Modal from "@cloudscape-design/components/modal";
import Button from "@cloudscape-design/components/button";
/* Recoil */
import { useRecoilValue, useSetRecoilState } from "recoil";
import { configStore } from "../stores/config";
import { userStore } from "../stores/access";
import { panelPaymentsUsersStore } from "../stores/panelPaymentsUsers";
import PanelPaymentsLogModal from "./PanelPaymentsLogModal"; // Предполагаемый компонент

class PanelPaymentsUsers extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			modalVisible: false,
			selectedUserId: null,
		};

		this.props.Interface.loadPanelPaymentsUsers();
	}

	compare(a, b) {
		const field = this.props.panelPaymentsUsers.sorting.sortingColumn.sortingField;
		if (a[field] < b[field]) {
			return this.props.panelPaymentsUsers.sorting.isDescending ? 1 : -1;
		}
		if (a[field] > b[field]) {
			return this.props.panelPaymentsUsers.sorting.isDescending ? -1 : 1;
		}
		return 0;
	}

	loadSessions = (userId) => {
		this.setState({ modalVisible: true, selectedUserId: userId });
	};

	closeModal = () => {
		this.setState({ modalVisible: false, selectedUserId: null });
	};

	render() {
		const { panelPaymentsUsers, setPanelPaymentsUsers, config, styles } = this.props;

		return (
			<>
				{panelPaymentsUsers.loaded && panelPaymentsUsers.error.text.length ? (
					<Box
						margin={{ bottom: "m" }}
						children={
							<Alert
								type="error"
								header="Error loading data:"
								children={
									<>
										<Box variant="p" children={panelPaymentsUsers.error.text} />
										<hr />
										<Box
											variant="p"
											children={
												<>
													request error code: {panelPaymentsUsers.error.code} | request timestamp: {panelPaymentsUsers.error.timestamp}
												</>
											}
										/>
									</>
								}
							/>
						}
					/>
				) : (
					<></>
				)}

				<Modal
					visible={this.state.modalVisible}
					onDismiss={this.closeModal}
					header="User Payment Logs"
					size="max"
					footer={
						<Box float="right">
							<Button variant="primary" onClick={this.closeModal}>
								Close
							</Button>
						</Box>
					}
				>
					{this.state.selectedUserId && (
						<PanelPaymentsLogModal styles={this.props.styles} doRoute={this.props.doRoute} userId={this.state.selectedUserId} Interface={this.props.Interface} />
					)}
				</Modal>

				<Table

					pagination={
						<Pagination
							disabled={!panelPaymentsUsers.loaded}
							currentPageIndex={panelPaymentsUsers.pagination.current}
							pagesCount={panelPaymentsUsers.pagination.total}
							onChange={(page) => {
								setPanelPaymentsUsers({
									...panelPaymentsUsers,
									pagination: {
										...panelPaymentsUsers.pagination,
										current: page.detail.currentPageIndex,
									},
								});
							}}
						/>
					}
					onSortingChange={(sorting) => {
						setPanelPaymentsUsers({
							...panelPaymentsUsers,
							sorting: sorting.detail,
							data: cloneDeep(panelPaymentsUsers.data).sort((a, b) => this.compare(a, b)),
						});
					}}
					columnDefinitions={[
						{
							id: "login",
							header: "User",
							cell: (item) => (
								<Link
									onFollow={() => {
										this.loadSessions(item.login);
									}}
								>
									{item.login}
								</Link>
							),
						},
					]}
					items={panelPaymentsUsers.data.slice(
						(panelPaymentsUsers.pagination.current - 1) * config.panelPaymentsUsers.perPage,
						panelPaymentsUsers.pagination.current * config.panelPaymentsUsers.perPage
					)}
					loading={!panelPaymentsUsers.loaded}
					sortingColumn={{ sortingField: panelPaymentsUsers.sorting.sortingColumn.sortingField }}
					sortingDescending={panelPaymentsUsers.sorting.isDescending}
					header={
						<Box
							margin={{ bottom: "m" }}
							children={
								<Header
									children="Payments Users"
									description="Below listed all payments users"
									counter={<>({panelPaymentsUsers.data.length})</>}
								/>
							}
						/>
					}
					empty="No users were found"
				/>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const panelPaymentsUsers = useRecoilValue(panelPaymentsUsersStore);
		const setPanelPaymentsUsers = useSetRecoilState(panelPaymentsUsersStore);
		const config = useRecoilValue(configStore);
		const setConfig = useSetRecoilState(configStore);
		const user = useRecoilValue(userStore);

		return (
			<Component
				{...props}
				user={user}
				config={config}
				setConfig={setConfig}
				panelPaymentsUsers={panelPaymentsUsers}
				setPanelPaymentsUsers={setPanelPaymentsUsers}
			/>
		);
	};
}

export default withRecoil(PanelPaymentsUsers);